'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDomElementId = exports.elementClassNames = exports.getPhysicalAncestorIds = exports.hasRetrievedAllAncestors = undefined;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns true if an elements entire ancestor tree has been retrieved.
 */
var hasRetrievedAllAncestors = exports.hasRetrievedAllAncestors = function hasRetrievedAllAncestors(elements, elementId) {
    var element = elements.get(elementId);

    if (!element) return false;

    var hasRetrievedAncestors = true;
    var prevElement = element;

    while (element && hasRetrievedAncestors) {
        hasRetrievedAncestors = hasRetrievedAncestors && !!element.get('location');
        prevElement = element;
        var parentId = element.getIn(['location', 'parentId']);
        element = elements.get(parentId);
    }

    var lastElementIsRoot = prevElement.getIn(['location', 'rootBoard']);
    return lastElementIsRoot && hasRetrievedAncestors;
};

/**
 * Gets the actual ancestors in the element's "physical" location.
 * This will only iterate over the 'parentIds' of each ancestor and will not consider aliases.
 */
// Lib
var getPhysicalAncestorIds = exports.getPhysicalAncestorIds = function getPhysicalAncestorIds(elements, elementId) {
    var ancestors = [];
    var currentElementId = elementId;
    while (currentElementId) {
        ancestors.push(currentElementId);
        var element = elements.get(currentElementId);
        currentElementId = element && !element.getIn(['location', 'rootBoard']) ? element.getIn(['location', 'parentId']) : null;
    }
    return ancestors;
};

var elementClassNames = exports.elementClassNames = function elementClassNames(prefix, props) {
    var inList = props.inList,
        isEditing = props.isEditing,
        isSelected = props.isSelected,
        isSingleSelected = props.isSingleSelected,
        isRemotelySelected = props.isRemotelySelected,
        isHovered = props.isHovered,
        canDrop = props.canDrop,
        className = props.className,
        isLocked = props.isLocked,
        filter = props.filter,
        isLineEdgeHovered = props.isLineEdgeHovered,
        transparent = props.transparent;


    return (0, _classnames2.default)(prefix, inList, className, filter, {
        editing: isEditing,
        selected: isSelected,
        'selected-single': isSingleSelected,
        'remote-selected': isRemotelySelected,
        'can-drop': isHovered && canDrop,
        locked: isLocked,
        'line-edge-can-drop': isLineEdgeHovered,
        transparent: transparent
    });
};

var getDomElementId = exports.getDomElementId = function getDomElementId(elementId) {
    return 'el-' + elementId;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementUtil.js
// module id = 105
// module chunks = 0